module.exports = __webpack_public_path__ + "static/media/runner.e4ef830a.svg";